import storage from '/home/pedrazzi/projetos/eds/ci4-shield-vuejs/src/composables/storage.js';
// https://developers.google.com/web/tools/workbox/modules/workbox-window
import { Workbox } from 'workbox-window'

export default function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    const wb = new Workbox('sw.js')

    wb.addEventListener('installed', (event) => {
      console.log('instalou sw.js')
      if (event.isUpdate) {
        if (
          confirm('Nova atualização disponível!. Clique em OK para atualizar')
        ) {
          window.location.reload()
        }
      }

      // NOTIFICAÇÃO
      if ('PushManager' in window) {
        const isNotify = Notification.permission === 'granted' ? !0 : !1
        if (!Notification.permission) {
          Notification.requestPermission(async (outcome) => {
            if (outcome === 'granted') {
              storage.set('isNotify', !0)
            } else {
              storage.set('isNotify', !1)
            }
          })
        }
      }
    })
    wb.register()
  }
}

/*
 * INSTALAR DESKTOP
 */

let deferredPrompt,
  isInstalled = storage.get('pwaInstalled') || !1

if (
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === !0
) {
  // User is currently navigating on the PWA so yes it's installed
  storage.set('pwaInstalled', !0)
  isInstalled = !0
} else {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    deferredPrompt = e
    storage.set('pwaInstalled', !1)
    isInstalled = !1
  })
  window.addEventListener('appinstalled', async () => {
    deferredPrompt = null
    console.log('App foi instalado')
    storage.set('pwaInstalled', !0)
    isInstalled = !0
  })
}
